<div class="game-dashboard-block school-class-compare-block">
  <div class="school-class-compare-block__headline">
    <brt-dashboard-boxes-head [data]="defaultHeadlineBlockData"></brt-dashboard-boxes-head>
  </div>

  <div class="school-class-compare-block__content">
    <div class="school-class-compare-block__content-headline">
      <div class="school-class-compare-block__categories">
        <brt-school-class-compare-block-categories [data]="categoriesSelectorData" (category-selected)="onCategorySelected($event)"></brt-school-class-compare-block-categories>
      </div>

      <div class="school-class-compare-block__legend" *ngIf="currentCategory !== 'trophies'">
        <brt-school-class-compare-block-legend [data]="legendItems"></brt-school-class-compare-block-legend>
      </div>
    </div>

    <div class="school-class-compare-block__category-wrapper">
      <brt-school-class-compare-block-chart [chartTarget]="'points'" [lineChartData]="pointsLineChartData" *ngIf="currentCategory === 'points' && pointsLineChartData"></brt-school-class-compare-block-chart>
      <brt-school-class-compare-block-chart [chartTarget]="'playTime'" [lineChartData]="playTimeLineChartData" *ngIf="currentCategory === 'time' && playTimeLineChartData"></brt-school-class-compare-block-chart>
      <brt-school-class-compare-block-trophies [data]="trophyData" *ngIf="currentCategory === 'trophies'"></brt-school-class-compare-block-trophies>
    </div>
  </div>
</div>
